module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-02-f0cb0b60a42970227fab92df7556955b.png";